import { useMemo, useState } from "react";
import { Box, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { getCurrencyObj } from "../constants";
import { SearchBar } from "../searchBar/SearchBar";
import { noOptionsFound, search, selectCurrency } from "../messages";
import { currency } from "../Currency";
import Text from "../text/Text";
import { setWalletCurrency } from "../../redux/actions";
import CommonHeader from "../CommonHeader";

const FiatCurrency = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { walletCurrency } = useSelector((state) => state.common);

  const [fiatCurrencyCode, setFiatCurrencyCode] = useState(
    walletCurrency?.code
  );
  const [searchValue, setSearchValue] = useState("");
  const cryptoCurrencies = ["BTC", "SATS", "USDT", "USDC", "XAUT"];
  const fiatCurrencies = currency.filter(
    (x) => !cryptoCurrencies.includes(x.code)
  );

  const filteredCurrencies = useMemo(() => {
    return fiatCurrencies?.filter(
      (x) =>
        x.code?.toLowerCase().includes(searchValue?.toLowerCase()) ||
        x.name?.toLowerCase().includes(searchValue?.toLowerCase())
    );
  }, [fiatCurrencies, searchValue]);

  const handleChange = (e) => {
    const newValue = e?.target?.value;

    if (newValue !== fiatCurrencyCode) {
      const newCurrencyObj = getCurrencyObj(newValue);
      dispatch(setWalletCurrency(newCurrencyObj));
      setFiatCurrencyCode(newCurrencyObj.code);
      navigate("/settings");
    }
  };

  return (
    <>
      <CommonHeader textAfterIcon={selectCurrency} icon="backArrow" />
      <Box className="options-container">
        <Box className="advance-settings-wrapper fiat-currency-wrapper">
          <Box className="currency-search-box">
            <SearchBar
              value={searchValue}
              handleChange={(e) => setSearchValue(e?.target?.value)}
              handleClear={() => setSearchValue("")}
              placeHolder={search}
            />
          </Box>
          <Box className="module-container">
            {filteredCurrencies?.length > 0 ? (
              <RadioGroup
                sx={{ gap: "16px" }}
                value={fiatCurrencyCode}
                onChange={handleChange}
              >
                {filteredCurrencies?.map((cur) => (
                  <FormControlLabel
                    key={cur.code}
                    value={cur.code}
                    control={<Radio />}
                    label={
                      <Box className="currency-radio-button-label">
                        <span>{cur.name}</span>
                        <span>{cur.code}</span>
                      </Box>
                    }
                    className="currency-radio-button-container"
                  />
                ))}
              </RadioGroup>
            ) : (
              <Text font="semibold" size={16}>
                {noOptionsFound}
              </Text>
            )}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default FiatCurrency;
